import type { SVGProps } from 'react';

const SvgReportsLibrary = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="reports-library">
      <path d="M29 6.06H13a1.22 1.22 0 0 1-1-.44l-1.74-2.08a2.74 2.74 0 0 0-2.09-1h-5A2.75 2.75 0 0 0 .4 5.33v21.32a2.75 2.75 0 0 0 2.75 2.75H29a2.75 2.75 0 0 0 2.75-2.75V8.81A2.75 2.75 0 0 0 29 6.06m1.25 20.59A1.25 1.25 0 0 1 29 27.9H3.15a1.25 1.25 0 0 1-1.25-1.25V21h4.39v-1.5H1.9v-3.64h7.29v-1.5H1.9v-9a1.25 1.25 0 0 1 1.25-1.28h5a1.26 1.26 0 0 1 .95.44l1.76 2.07a2.74 2.74 0 0 0 2.09 1H29a1.25 1.25 0 0 1 1.25 1.25Z" />
      <path d="M20.35 10.66a7 7 0 1 0 7 7 7 7 0 0 0-7-7m5.48 6.28H21.1v-4.73a5.56 5.56 0 0 1 4.73 4.73m-5.48 6.29a5.54 5.54 0 0 1-.75-11v5.48a.74.74 0 0 0 .75.75h5.48a5.55 5.55 0 0 1-5.48 4.77" />
    </g>
  </svg>
);

export default SvgReportsLibrary;
